<template>
  <div class="can-pedalsure hp-block-container">
    <h3 class="hp-block-title">Why you can Pedalsure...</h3>
    <div class="element-container">
      <div class="element">
        <div class="icon price-match-promise">
          <img
            src="~/assets/images/icons/blue/price-match-promise.svg"
            class="alt"
            alt="payment promise icon"
            width="1000"
            height="500"
          />
        </div>
        <div class="subtitle">Outstanding value</div>
        <div class="content-text">
          <span>
            Find a cheaper quote for the same cover and we’ll match it.
          </span>
        </div>
      </div>
      <div class="element rating-tile">
        <div class="icon">
          <!-- Our own stars (helpers/rating.js), replacing a 170 KB third-party
               image (PS-129/PS-56). RatingStars carries its own accessible
               name, "Rated 4.4 out of 5". -->
          <RatingStars :size="32" />
        </div>
        <div class="subtitle">Excellent rating</div>
        <div class="content-text">
          <span> Rated Excellent by cyclists across the country </span>
        </div>
      </div>
      <div class="element">
        <div class="icon">
          <!-- `icon` belongs on the wrapper only: on the <img> too it made
               the image itself match the icon-band rule and collapse to 0x0. -->
          <img
            src="~/assets/images/icons/blue/super-fast-service.svg"
            class="alt"
            alt="super fast service icon"
            width="80"
            height="80"
          />
        </div>
        <div class="subtitle">Super-fast service</div>
        <div class="content-text">
          <span> We aim to cover and pay out faster than anyone else. </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RatingStars from '@/components/RatingStars'

export default {
  components: { RatingStars },
}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  border-top: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}

.element-container {
  display: grid;
  grid-template-columns: auto;
  text-align: center;
  @include tablet {
    grid-template-columns: 1fr 1fr 1fr;
  }
  // The three artworks are different heights (a 160px-wide badge, a rating
  // image, a 60px icon). Centring each column's content vertically therefore
  // put the three titles at three different heights. Instead every icon sits
  // in one fixed-height band, so the titles — and the text under them — line
  // up across all three.
  .element {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 30px 0;
    @include mobile {
      width: 70%;
      margin: 0 auto;
    }
    @include tablet {
      padding: 0 20px;
      margin: 20px 0;
    }
    // Direct child only. `class="icon alt"` on the inner <img> is a common
    // pattern in this codebase, and an unscoped `.icon` here would size the
    // image as if it were the band and collapse it to 0x0.
    > .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 110px;
      width: auto;
      max-width: 220px;
      margin-bottom: 20px;
      color: $ps-primary;

      // A definite height, not `auto`. Most icons in assets/images/icons/blue
      // carry a viewBox but no width/height, so they have no intrinsic size and
      // `width:auto; height:auto` collapses them to 0x0.
      img {
        height: 100%;
        width: auto;
        max-width: 100%;
        object-fit: contain;
      }
    }
    > .price-match-promise {
      width: 160px;
    }
    .subtitle {
      // Fixed height reserves room for a title that wraps on narrow screens,
      // keeping the descriptions aligned too.
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 2.6rem;
      margin-bottom: 12px;
      font-size: 1.5rem;
      line-height: 1.3;
      color: $ps-ink;
      @include desktop {
        font-size: 1.8rem;
      }
    }
    .content-text {
      font-size: $ps-text-small;
      font-family: $family-regular;
      color: $ps-body-color;
      @include tablet {
        font-size: $ps-text-body;
        line-height: 1.5;
      }
    }
  }
  .rating-tile {
    border: 0.5px solid $ps-border;
    border-left: 0;
    border-right: 0;
    // Icon sizing intentionally not overridden here — this column shares the
    // same fixed-height icon band as the other two so the titles line up.
    @include tablet {
      border-top: 0;
      border-bottom: 0;
      border-left: 0.5px solid $ps-border;
      border-right: 0.5px solid $ps-border;
    }
  }
}
</style>
